import { assertNever } from "@msys/common";
import { Button } from "@mui/material";
import { useTranslate } from "@tolgee/react";
import { RestrictedByOrganisationPermissionWithDebug } from "../../../auth/RestrictedByOrganisationPermission.js";
import { getCrmLinkingStatus } from "../getCrmLinkingStatus.js";
import { CrmCompanyConnectedLabel } from "./CrmCompanyConnectedLabel.js";
import { CrmCompanyInviteButton } from "./CrmCompanyInviteButton.js";

interface Props {
  crmCompanyId: string;
  linkedSystemOrganisationId?: string | null;
  isInvited: boolean;
  refetchQueries: string[];
}

export function CrmCompanyLinkingStatusCell({
  crmCompanyId,
  linkedSystemOrganisationId,
  isInvited,
  refetchQueries,
}: Props) {
  const { t } = useTranslate("CrmOrganisations");

  const status = getCrmLinkingStatus({ linkedSystemOrganisationId, isInvited });

  switch (status) {
    case "linked":
      return <CrmCompanyConnectedLabel />;
    case "invited":
      return (
        <Button size="extra-small" variant="outlined" color="primary" disabled>
          {t("Invited")}
        </Button>
      );
    case "notInvited":
      return (
        <RestrictedByOrganisationPermissionWithDebug permission="organisation_integration_update">
          <CrmCompanyInviteButton
            crmCompanyId={crmCompanyId}
            refetchQueries={refetchQueries}
            label={t("Invite")}
            size="extra-small"
          />
        </RestrictedByOrganisationPermissionWithDebug>
      );
    default:
      assertNever(status);
  }
}
